var _defs, _circle, _path, _path2, _path3, _ellipse, _circle2, _circle3, _circle4, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBowlsFeeders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 8,
    x2: 56,
    y1: 8,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0F2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0FDFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bowl",
    x1: 11,
    x2: 53,
    y1: 34,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F87171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC2626"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 29,
    fill: "url(#bg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0EA5E9",
    d: "M39 12h12v31H39z",
    rx: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#BAE6FD",
    d: "M42 18h6v16h-6z",
    rx: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bowl)",
    d: "M10 37h36l-5 14H15l-5-14Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28,
    cy: 37,
    fill: "#FCA5A5",
    rx: 18,
    ry: 5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 36,
    r: 2.3,
    fill: "#A16207"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 35,
    r: 2.1,
    fill: "#92400E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 37,
    r: 2.2,
    fill: "#A16207"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#14B8A6",
    d: "M18 18h14v18H18z",
    rx: 5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#99F6E4",
    d: "M21 23h8v9h-8z",
    rx: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBowlsFeeders);
export default __webpack_public_path__ + "static/media/bowls-feeders.5860ae0ab9c949fb69ea508e4df3a176.svg";
export { ForwardRef as ReactComponent };